import CardPorServicios from "../../Components/CardPorServicios/CardPorServicios";
import  {CardPorServiciosData} from "../../Data/CardPorServicios";

function CardPorServiciosPage() {
  const handleSeleccionar = (tematica) => {
    console.log("Temática seleccionada:", tematica);

    // Acá posteriormente podés enviar al formulario
    // con la temática seleccionada.
  };

  return (
    <CardPorServicios
      titulo="¿Qué necesita resolver tu negocio?"
      subtitulo="Elegí una temática y contanos qué estás buscando. Te ayudamos a encontrar una solución."
      tematicas={CardPorServiciosData}
      onSeleccionar={handleSeleccionar}
    />
  );
}


export default CardPorServiciosPage;